import { render, staticRenderFns } from "./TeruteruLogos.vue?vue&type=template&id=cc5361be&scoped=true"
import script from "./TeruteruLogos.vue?vue&type=script&lang=js"
export * from "./TeruteruLogos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5361be",
  null
  
)

export default component.exports